import DailyMessage from "./components/DailyMessage";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Clocks from "./components/Clocks";
import Archive from "./pages/Archive";
import About from "./pages/About";
import Contact from "./pages/Contact";
import RateBar from "./components/RateBar";
import { useState, useEffect } from "react";
import { DataContext } from "./index";
import Main from "./components/Main";
import { io } from "socket.io-client";
import Calculator from "./components/Calculator";
import { useDispatch } from "react-redux";
import {
  yesterdayVisitors,
  todayVisitors,
  totalVisitors,
} from "./store/action";

function App() {
  const [show, setShow] = useState(false);
  const [page, setPage] = useState(1);
  const [coinPrice, setCoinPice] = useState();
  const [currencyPrice, setCurrencyPrice] = useState();
  const [nimaiiPrice, setNimaiiPrice] = useState();
  const [cryptoPrice, setCryptoPrice] = useState();
  const [titles, setTitles] = useState();
  const [coinsTitle, setCoinsTitle] = useState([]);
  const [msg, setMsg] = useState();
  const [config, setConfig] = useState();

  const dispatch = useDispatch();
  useEffect(() => {
    try {
      const socket = io(`${process.env.REACT_APP_URL}`, {
        transports: ["polling"],
      });

      socket.on("getCurrencies", async (data) => {
        const coppied = [];

        const curs1 = await data.filter(
          (curr) => curr.id === 8 || curr.id === 9
        );
        const curs2 = await data.filter(
          (curr) => curr.id !== 1 && curr.id !== 2 && curr.id < 8
        );
        const curs3 = await data.filter(
          (curr) => curr.id === 1 || curr.id === 2
        );
        const curs4 = await data.filter(
          (curr) => curr.id !== 1 && curr.id !== 2 && curr.id > 9
        );

        coppied.push(...curs1, ...curs2, ...curs3, ...curs4);

        setCurrencyPrice(coppied);

        // const coppied = [];
        // data.forEach((element, i) => {
        //   coppied[i + 2] = element;
        // });

        // coppied[0] = coppied[9];
        // coppied[1] = coppied[10];
        // coppied.splice(9, 1);
        // coppied.splice(9, 1);
        // setCurrencyPrice(coppied);
      });
      socket.on("msg", (data) => {
        setMsg(data.msg);
      });
      socket.on("getCoins", (data) => {
        setCoinPice(data);
      });
      socket.on("getNimaiis", (data) => {
        setNimaiiPrice(data);
      });

      fetch(`${process.env.REACT_APP_URL}/api/getallcoins`, { method: "POST" })
        .then((resl) => {
          return resl.json();
        })
        .then((res) => {
          setCoinPice(res);
          setCoinsTitle(...coinsTitle, res[0].coin.name);
          setCoinsTitle(...coinsTitle, res[1].coin.name);
          setCoinsTitle(...coinsTitle, res[2].coin.name);
          setCoinsTitle(...coinsTitle, res[3].coin.name);
          setCoinsTitle(...coinsTitle, res[4].coin.name);
          setCoinsTitle(...coinsTitle, res[5].coin.name);
          setCoinsTitle(...coinsTitle, res[6].coin.name);
          setCoinsTitle(...coinsTitle, res[7].coin.name);
        })
        .catch((e) => {
          // console.log(e);
        });
      fetch(`${process.env.REACT_APP_URL}/api/getallcurrencies`, {
        method: "POST",
      })
        .then((resl) => {
          return resl.json();
        })
        .then(async (res) => {
          dispatch(yesterdayVisitors(res.yesterdayCountVal));
          dispatch(todayVisitors(res.todayCountVal));
          dispatch(totalVisitors(res.totalCountVal));

          const coppied = [];

          const curs1 = await res.AllCurrensies.filter(
            (curr) => curr.id === 8 || curr.id === 9
          );
          const curs2 = await res.AllCurrensies.filter(
            (curr) => curr.id !== 1 && curr.id !== 2 && curr.id < 8
          );
          const curs3 = await res.AllCurrensies.filter(
            (curr) => curr.id === 1 || curr.id === 2
          );
          const curs4 = await res.AllCurrensies.filter(
            (curr) => curr.id !== 1 && curr.id !== 2 && curr.id > 9
          );

          coppied.push(...curs1, ...curs2, ...curs3, ...curs4);
          setCurrencyPrice(coppied);

          // const coppied = [];
          // res.AllCurrensies.forEach((element, i) => {
          //   coppied[i + 2] = element;
          // });

          // coppied[0] = coppied[9];
          // coppied[1] = coppied[10];
          // coppied.splice(9, 1);
          // coppied.splice(9, 1);
          // setCurrencyPrice(coppied);
        })
        .catch((e) => {
          // console.log(e);
        });

      fetch(`${process.env.REACT_APP_URL}/api/getallnimaiis`, {
        method: "POST",
      })
        .then((resl) => {
          return resl.json();
        })
        .then((res) => {
          setNimaiiPrice(res);
        })
        .catch((e) => {
          //console.log(e);
        });
      fetch(`${process.env.REACT_APP_URL}/api/getTitles`, { method: "POST" })
        .then((resl) => {
          return resl.json();
        })
        .then((res) => {
          setTitles(res);
        })
        .catch((e) => {
          //console.log(e);
        });

      fetch(
        "http://api.coinlayer.com/live?access_key=17aedf5f8decb5a4dfcd587a7f30ca54",
        { method: "POST" }
      )
        .then((resl) => {
          return resl.json();
        })
        .then((res) => {
          setCryptoPrice({ rates: res.rates, timestamp: res.timestamp });
        })
        .catch((e) => {
          //console.log(e);
        });

      fetch(`${process.env.REACT_APP_URL}/api/getmsg`, { method: "POST" })
        .then((resData) => {
          return resData.json();
        })
        .then((res) => {
          setMsg(res.msg);
        })
        .catch((err) => {});

      fetch(`${process.env.REACT_APP_URL}/api/getConfig`, {
        method: "GET",
      })
        .then((resl) => {
          return resl.json();
        })
        .then((res) => {
          setConfig(res);
        })
        .catch((e) => {
          // console.log(e);
        });
    } catch (err) {
      // console.log(err);
    }
  }, []);

  return (
    <>
      <DataContext.Provider
        value={{
          showCalc: [show, setShow],
          page: [page, setPage],
          currencyPrice,
          coinPrice,
          cryptoPrice: {
            BTC: cryptoPrice?.rates?.BTC,
            ETH: cryptoPrice?.rates?.ETH,
            DOGE: cryptoPrice?.rates?.DOGE,
            USDT: cryptoPrice?.rates?.ETH,
            time: cryptoPrice?.timestamp,
          },
          titles,
          nimaiiPrice,
          coinsTitle,
          msg: msg,
        }}
      >
        <div className="container">
          <div className="headers-container">
            <Header />
            {/* <DailyMessage /> */}
            <RateBar message={msg} />
          </div>
          {show ? <Calculator /> : null}
          {page === 1 ? (
            <div className="main">
              <Main />
              <Clocks />
            </div>
          ) : null}
          {page === 2 ? (
            <>
              <Archive />
            </>
          ) : null}
          {page === 3 ? <About config={config} /> : null}
          {page === 4 ? <Contact config={config} /> : null}
          <Footer config={config} />
        </div>
      </DataContext.Provider>
    </>
  );
}

export default App;
